// This is just an example,
// so you can safely delete all default props below

export default {
    change_password: 'Bytt passord',
    current_password: 'Nåværende passord',
    new_password: 'Nytt passord',
    repeat_password: 'Gjenta passord',
    error_current_password: 'Nåværende passord må oppgis.',
    error_new_password: 'Passordet må være minst 8 tegn, og må inneholde store/små bokstaver, tall og symboler.',
    error_repeat_password: 'Repetert passord må være det samme som nytt passord.',
    error_worng_current_password: 'Nåværende passord er ikke gyldig.',
    succeeded: 'Passordet ditt er nå endret.',
    failed: 'En feil oppstod.'
}
